import { Tooltip, IconButton } from '@material-ui/core';
import i18next from 'i18next';
import React from 'react';
import { tooltipEnterDelay } from 'src/config';
import HealingIcon from '@material-ui/icons/Healing';
import { API_URLS } from 'src/common/ApiService';
import { useRequest } from 'src/common/useRequestHook';
import { RequestMethod } from 'src/utils/request';
import { Order } from 'src/models/Order';
import { useDispatch } from 'react-redux';
import { loadOrderSuccess } from '../OrderActions';
import { showNotification } from 'src/common/notifications/NotificationsActions';
import { useConfirmationDialog } from 'src/common/confirmationDialog/useConfirmationDialog';
import { NotificationVariant } from 'src/models/Notification';
import { appPaths } from 'src/AppRouterService';
import { generatePath } from 'react-router-dom';

interface Props {
    disabled: boolean;
    isShown: boolean;
    className: string;
    orderId?: string;
}

export const CreateClaimButton: React.FC<Props> = ({
    disabled,
    isShown,
    className,
    orderId
}) => {
    const dispatch = useDispatch();
    const confirm = useConfirmationDialog();
    const [createClaim, { inProgress }] = useRequest<Order>(
        RequestMethod.POST,
        API_URLS.createOrderClaim
    );

    if (!isShown) {
        return null;
    }

    const handleCreateClaim = async () => {
        if (!(await confirm(i18next.t('order.createClaimConfirmation')))) {
            return;
        }
        const updatedOrder = await createClaim({ orderId });

        const lastOrderClaimId =
            updatedOrder.claims[updatedOrder.claims.length - 1];
        dispatch(loadOrderSuccess(updatedOrder));
        dispatch(
            showNotification({
                id: `claim_created_${Date.now()}`,
                variant: NotificationVariant.Success,
                text: i18next.t('order.createClaimSuccess'),
                link: generatePath(appPaths.order, {
                    orderId: lastOrderClaimId
                })
            })
        );
    };

    return (
        <Tooltip
            title={i18next.t('order.createClaim')}
            enterDelay={tooltipEnterDelay}
        >
            <div className={className}>
                <IconButton
                    color="inherit"
                    onClick={handleCreateClaim}
                    disabled={disabled || inProgress}
                >
                    <HealingIcon />
                </IconButton>
            </div>
        </Tooltip>
    );
};
